import React, { useState, useEffect } from "react";

export default function QuoteActions({
  onSave,
  onApprove,
  onReject,
  isEdit,
  docStatus, // ⬅ เพิ่มรับสถานะเอกสาร
  isDataLoaded = false, // ⬅ เพิ่ม prop เพื่อบอกว่าโหลดเสร็จแล้วหรือยัง
}) {
  const userRole = localStorage.getItem("role");
  const isAdmin = userRole === "Admin";

  const [canShowApprovalButtons, setCanShowApprovalButtons] = useState(false);

  useEffect(() => {
    // รอให้ข้อมูลโหลดเสร็จก่อน
    if (!isDataLoaded) {
      setCanShowApprovalButtons(false);
      return;
    }

    // เมื่อข้อมูลโหลดเสร็จแล้ว คำนวณเงื่อนไข
    if (docStatus !== undefined && docStatus !== null) {
      const shouldShow = isEdit && isAdmin && Number(docStatus) !== 2;
      setCanShowApprovalButtons(shouldShow);
    }
  }, [isEdit, isAdmin, docStatus, isDataLoaded]);

  return (
    <div className="flex items-center justify-between w-full">

      {/* ===== ฝั่งซ้าย ===== */}
      {canShowApprovalButtons ? (
        <div className="flex gap-4">
          <button
            type="button"
            onClick={onApprove}
            className="w-[200px] h-[40px] rounded-[10px] bg-green-600 text-white font-semibold shadow hover:bg-green-700 transition flex items-center justify-center gap-2"
          >
            อนุมัติ
          </button>

          <button
            type="button"
            onClick={onReject}
            className="w-[200px] h-[40px] rounded-[10px] bg-red-600 text-white font-semibold shadow hover:bg-red-700 transition flex items-center justify-center gap-2"
          >
            ไม่ผ่านการอนุมัติ
          </button>
        </div>
      ) : (
        <div></div>
      )}

      {/* ===== ปุ่มบันทึก & ยกเลิก ===== */}
      <div className="flex gap-4">
        <button
          type="button"
          onClick={() => window.history.back()}
          className="w-[200px] h-[40px] rounded-[10px] border border-[#E13F57] text-[#E13F57] font-semibold shadow-sm hover:bg-[#fff0f3] transition flex items-center justify-center gap-2"
        >
          ยกเลิก
        </button>

        <button
          type="button"
          onClick={onSave}
          className="w-[200px] h-[40px] rounded-[10px] bg-[#E13F57] text-white font-semibold shadow hover:bg-[#c92f47] transition flex items-center justify-center gap-2"
        >
          บันทึก
        </button>
      </div>
    </div>
  );
}
